import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui/button';
import { ArrowRight, User } from 'lucide-react';

export const CTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-primary/3 to-primary/5 dark:from-primary/10 dark:via-primary/5 dark:to-primary/10" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,107,0,0.08),transparent_70%)] dark:bg-[radial-gradient(ellipse_at_center,rgba(255,107,0,0.15),transparent_70%)]" />
      
      <div className="container-main relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          
          className="text-center"
        >
          <h2 className="text-4xl md:text-6xl font-black mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/gameservers">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90 font-bold uppercase tracking-wider h-14 px-10 glow-hover"
                data-testid="cta-get-started"
              >
                {t('cta.button')}
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <a
              href="https://deinserverhost.de/store/clientarea.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                variant="outline" 
                size="lg"
                className="border-2 border-primary/30 hover:border-primary h-14 px-10"
                data-testid="cta-login"
              >
                <User className="w-5 h-5 mr-2" />
                {t('cta.login')}
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
